function calculateM2Price() {
    const tilePrice = parseFloat(document.getElementById('tilePrice').value);
    const tileM2 = parseFloat(document.getElementById('tileM2').value);
    const tileAmount = parseFloat(document.getElementById('tileAmount').value);

    // Calculate number of tiles needed
    const tilesNeeded = Math.ceil(tileAmount / tileM2);

    // Calculate total price based on the tiles
    const totalPrice = tilesNeeded * tilePrice;
    
    // Update the result in the HTML
    document.querySelector('#totalPriceResult span').innerText = totalPrice.toFixed(2);
    document.querySelector('#tilesNeeded span').innerText = tilesNeeded;
}

